import { FOUNDER } from '@/data/content';

const Founder = () => {
  return (
    <section className="founder-section" data-testid="founder-section">
      <div className="container">
        <div className="founder-grid">
          <div className="founder-image-wrap">
            <img src={FOUNDER.image} alt={FOUNDER.name} data-testid="founder-image" />
          </div>
          <div className="founder-content">
            <div className="section-eyebrow" style={{ textAlign: 'left' }}>About Our Founder</div>
            <h2>Meet <span className="gold-gradient">{FOUNDER.name}</span></h2>
            <div className="founder-role">{FOUNDER.title}</div>
            <div className="founder-quals">
              "{FOUNDER.qualification} — {FOUNDER.university}"
            </div>
            <div className="founder-bio">
              <p>
                Dr. Irfan Aamer Ansari completed his PhD in Pharmaceutical & Biomolecular Sciences from the University of Turin, Italy.
              </p>
              <p>
                Having studied, researched and lived in Italy, he provides students with genuine guidance based on real European academic experience.
              </p>
              <p>
                Unlike traditional consultancies, EuroElite offers mentorship from someone who has personally navigated the Italian education system and successfully built an international academic career.
              </p>
            </div>
            <div className="founder-highlights">
              {FOUNDER.highlights.map((h, i) => (
                <div key={i} className="founder-highlight" data-testid={`founder-highlight-${i}`}>{h}</div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Founder;
